import React from 'react'
import { Row, Col, Button } from 'reactstrap'
import { Steps } from '../hooks/useAssignFormState'

interface ActionButtonsProps {
  activeTab: number
  isStepValid: boolean
  isConfirmed: boolean
  onCancel: () => void
  onPrevious: () => void
  onNext: () => void
  onSubmit: (e: React.FormEvent) => void
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  activeTab,
  isStepValid,
  isConfirmed,
  onCancel,
  onPrevious,
  onNext,
  onSubmit,
}) => {
  return (
    <>
      <hr />
      <Row>
        <Col className="text-right">
          <Button className="btn-fixed-width" color="link" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            className="btn-fixed-width"
            color="primary"
            disabled={activeTab === Steps.School}
            onClick={onPrevious}
          >
            Previous
          </Button>
          {activeTab < Steps.Confirm && (
            <Button
              className="btn-fixed-width"
              color="primary"
              disabled={!isStepValid}
              onClick={onNext}
            >
              Next
            </Button>
          )}
          {activeTab >= Steps.Confirm && (
            <Button
              className="btn-fixed-width"
              color="primary"
              disabled={!isConfirmed || !isStepValid}
              onClick={onSubmit}
            >
              Submit
            </Button>
          )}
        </Col>
      </Row>
    </>
  )
}

export default ActionButtons
